/* eslint-disable react/no-danger */
import React from 'react';
import Img from 'img';
import Container from 'container';
import Headline from 'headline';
import s from './lp_article.module.scss';

export default function LpArticle({
  image,
  main_title,
  first_paragraph,
  title,
  subtitle,
  second_paragraph
}) {
  return (
    <>
      <Container className={s.root}>
        <div className={s.wrapper}>
          <div className={s.imgWrapper}>
            <Img
              className={s.img}
              src={image}
              alt={image?.id}
            />
          </div>

          {/* Text Container */}
          <div className={s.textContainer}>
            {/* First Paragraph */}
            <Headline className={s.mainTitle} h2 left black>
              {main_title}
            </Headline>
            <p className={s.text}>{first_paragraph}</p>

            {/* Second Paragraph */}
            <Headline lassName={s.title} h3 left black>
              {title}
            </Headline>
            <p className={s.subtitle}>
              {subtitle}
            </p>
            <p className={s.text} dangerouslySetInnerHTML={{ __html: second_paragraph }} />
          </div>
        </div>
      </Container>
      <hr className={s.line} />
    </>
  );
}
